import React from "react";

const style = { flexGrow: 1 };
/** Spacer
 * @example <Spacer />
 */
function Spacer() {
  return <div style={style} />;
}
/** Spacer
 * @example <Spacer />
 */
export default Spacer;
